import axios from 'axios';


//分页查询购买商品
export function status(params) {
  return axios({
    url: '/gold/checkin/status',
    method: 'get',
    params,
  });
}


//流水列表 
export function list(params) {
  return axios({
    url: '/gold/flow/list',
    method: 'get',
    params,
  });
}

//查询账户信息 
export function account(params) {
  return axios({
    url: '/gold/account',
    method: 'get',
    params,
  });
}

//提现记录
export function recordList(params) {
  return axios({
    url: '/gold/withdraw/list',
    method: 'get',
    params,
  });
}
//绑定微信提现账户
export function bind(data) {
  return axios({
    url: '/ucenter/api/withdraw/binding',
    method: 'post',
    data,
  });
}

//查询绑定账户信息
export function bindAccounts(params) {
  return axios({
    url: '/ucenter/api/withdraw/accounts',
    method: 'get',
    params,
  });
}

// 解绑账户 
export function unbindAccounts(data) {
  return axios({
    url: '/ucenter/api/withdraw/unbind',
    method: 'post',
    data,
  });
}

//确定提现
export function withdraw(data) {
  return axios({
    url: '/gold/withdraw',
    method: 'post',
    data,
  });
}